// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"235":"43f4843b","256":"b8783088","296":"6205a45f","312":"ebba0f16","329":"03d140e3","453":"3ac371f3","708":"525fc7b6","818":"60423c8a","839":"8b764094","845":"d23b3434"}[chunkId] + ".chunk.js";
};